import { render } from "./CoursesPageTwo.vue?vue&type=template&id=3b3194ca"
import script from "./CoursesPageTwo.vue?vue&type=script&lang=js"
export * from "./CoursesPageTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__